module.exports = __webpack_public_path__ + "static/img/图层28.7df7049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层28.png
// module id = GbSN
// module chunks = 0